import type { DateTime } from "luxon";
import { countsPunchesOnPastDays } from "./demoStaffingRules";
import type { DayItem, DayStats, NurseInShift } from "./models";

/**
 * A day before today that already has punches. On these days the Staffing page shows the
 * actual (punched) numbers instead of the scheduled ones.
 */
export const isPastDayWithPunches = (date: DateTime, shiftsActual: readonly NurseInShift[], now: DateTime): boolean =>
	date < now.startOf("day") && shiftsActual.length > 0;

/** The day's stats the header shows: actual on a past day with punches, scheduled otherwise. */
export const activeDayStats = (dayItem: DayItem, now: DateTime): DayStats =>
	isPastDayWithPunches(dayItem.date, dayItem.shiftsActual, now) ? dayItem.dayStatsActual : dayItem.dayStats;

/**
 * The staff number on the day card. Departments that count punches show the day badge's number
 * (actual on past days with punches); everyone else shows the scheduled shift count.
 */
export const dayCardStaffCount = (dayItem: DayItem, departmentId: string, now: DateTime): number =>
	countsPunchesOnPastDays(departmentId) ? activeDayStats(dayItem, now).totalStaff : dayItem.shifts.length;
